import './constants';
import { _M2d } from './internal';
export const duration = (durationInput, durationUnit) => {
    switch (durationUnit) {
        case 's':
            return durationInput * 1000 /* MS.s */;
        case 'm':
            return durationInput * 60000 /* MS.m */;
        case 'h':
            return durationInput * 3600000 /* MS.h */;
        case 'd':
            return durationInput * 86400000 /* MS.d */;
        case 'w':
            return durationInput * 604800000 /* MS.w */;
        case 'y':
            // Years are converted to months
            durationInput *= 12;
        /* falls through */
        case 'M':
            return Math.round(_M2d(durationInput)) * 86400000 /* MS.d */;
    }
    return durationInput;
};
//# sourceMappingURL=duration.js.map